/**
 * 13 位时间戳字符串转换为 10 位字符串
 * 1626075658000 -> 1626075658
 */

export var convertTimestamp = function convertTimestamp(timestamp) {
  if (typeof timestamp === 'string') {
    timestamp = parseInt(timestamp);
  }
  var seconds = Math.floor(timestamp / 1000);
  return seconds;
};
//# sourceMappingURL=date.js.map